export default __webpack_public_path__ + "static/media/logo_century.3ccb573b.png";